<template>
<div class="code-samples">
  <div class="code-pills">
    <div class="code-pill"
      :class="{ active: activeCodeSample === 'curl' }"
      @click="activateCodeSample('curl')"
      >CURL</div>
    <div class="code-pill"
      :class="{ active: activeCodeSample === 'php' }"
      @click="activateCodeSample('php')"
      >PHP</div>
  </div>
  <div class="">
    <div :class="{ hidden: activeCodeSample !== 'curl' }" class="code-sample">
      <pre><code id="curl" class="bash">
# As simple as ABC
curl -H "Authorization: {api_key}" \
https://api.jsonwhoisapi.com/v1/whois?identifier=google.com
      </code></pre>
    </div>
    <div :class="{ hidden: activeCodeSample !== 'php' }" class="code-sample">
      <pre><code id="php" class="PHP">
// Set authentication information
Unirest\Request::auth($customer_id, $api_key);
$headers = array("Accept" => "application/json");
$url = "https://jsonwhoisapi.com/api/v1/whois?identifier=google.com";
$response = Unirest\Request::get($url, $headers);
      </code></pre>
    </div>
  </div>
</div>
</template>
<script>
import hljs from 'highlight.js'

export default {
  data () {
    return {
      activeCodeSample: 'curl'
    }
  },
  mounted () {
    this.highlightSyntax()
  },
  computed: {
  },
  methods: {
    activateCodeSample (lang) {
      this.activeCodeSample = lang
      this.highlightSyntax()
    },
    highlightSyntax () {
      hljs.highlightBlock(document.getElementById(this.activeCodeSample))
    }
  }
}
</script>
<style>
.hljs{display:block;overflow-x:auto;padding:0.5em;color:#abb2bf;background:#282c34}.hljs-comment,.hljs-quote{color:#5c6370;font-style:italic}.hljs-doctag,.hljs-keyword,.hljs-formula{color:#c678dd}.hljs-section,.hljs-name,.hljs-selector-tag,.hljs-deletion,.hljs-subst{color:#e06c75}.hljs-literal{color:#56b6c2}.hljs-string,.hljs-regexp,.hljs-addition,.hljs-attribute,.hljs-meta-string{color:#98c379}.hljs-built_in,.hljs-class .hljs-title{color:#e6c07b}.hljs-attr,.hljs-variable,.hljs-template-variable,.hljs-type,.hljs-selector-class,.hljs-selector-attr,.hljs-selector-pseudo,.hljs-number{color:#d19a66}.hljs-symbol,.hljs-bullet,.hljs-link,.hljs-meta,.hljs-selector-id,.hljs-title{color:#61aeee}.hljs-emphasis{font-style:italic}.hljs-strong{font-weight:bold}.hljs-link{text-decoration:underline}
</style>



// WEBPACK FOOTER //
// app/javascript/components/home/code-samples.vue?0de9093a